import { SvgIcon, SvgIconProps } from '@mui/material';

export const RedoIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    sx={{ fill: 'none', stroke: 'white' }}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4995 6.57658L17.7402 5L17.0395 7.67873L14.4995 6.57658Z"
      fill="white"
      stroke="white"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 16.2454C13.1304 17.3433 11.3919 18 9.5 18C5.08172 18 1.5 14.4183 1.5 10C1.5 5.58172 5.08172 2 9.5 2C12.2497 2 14.6753 3.38723 16.1153 5.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
);
